import React from "react";
import PropTypes from "prop-types";

import { Grid, Icon, Segment } from "semantic-ui-react";

import useRedtailUrl from "components/Crm/hooks/useRedtailUrl";
import PopupMenu from "components/PopupMenu";

import { getOrderedClientName } from "../../../data/libs/clients";

export default function HouseholdMemberDisplayRow({
  householdMember,
  hub,
  isRedtailIntegrated,
  clientExternalId,
  piiMask,
  onPopupOpen,
  onPopupClose,
  onDeleteMember,
  onEditMember,
}) {
  const redtailUrl = useRedtailUrl();

  let buttons;
  if (isRedtailIntegrated) {
    buttons = [
      {
        content: "Edit Member in Redtail",
        icon: "edit",
        onClick: () => {
          window.open(
            `${redtailUrl}/contacts/${clientExternalId}/family`,
            "_blank"
          );
        },
      },
      {
        content: "Remove Member",
        icon: "remove",
        onClick: onDeleteMember,
      },
    ];
  } else {
    buttons = [
      {
        content: "Edit Member",
        icon: "edit",
        onClick: onEditMember,
      },
      {
        content: "Remove Member",
        icon: "remove",
        onClick: onDeleteMember,
      },
    ];
  }

  return (
    <Segment>
      <Grid divided>
        <Grid.Row>
          <Grid.Column
            className={piiMask("fs-block dd-privacy-mask")}
            width={8}
          >
            {getOrderedClientName(householdMember.client, hub)}
          </Grid.Column>
          <Grid.Column width={6}>{householdMember.title}</Grid.Column>
          <Grid.Column textAlign="center" width={2}>
            <PopupMenu
              buttons={buttons}
              onOpen={onPopupOpen}
              onClose={onPopupClose}
              open={householdMember.popupOpen}
              popperModifiers={{
                preventOverflow: {
                  boundariesElement: "window",
                  enabled: false,
                },
              }}
              trigger={<Icon name="ellipsis horizontal" link color="grey" />}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
}

HouseholdMemberDisplayRow.propTypes = {
  clientExternalId: PropTypes.string.isRequired,
  householdMember: PropTypes.shape({
    client: PropTypes.object.isRequired,
    popupOpen: PropTypes.bool,
    title: PropTypes.string.isRequired,
  }).isRequired,
  hub: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  isRedtailIntegrated: PropTypes.bool.isRequired,
  onDeleteMember: PropTypes.func.isRequired,
  onEditMember: PropTypes.func.isRequired,
  onPopupClose: PropTypes.func.isRequired,
  onPopupOpen: PropTypes.func.isRequired,
  piiMask: PropTypes.func.isRequired,
};
